import { render, staticRenderFns } from "./RecoveryStart.vue?vue&type=template&id=46e26b5c&scoped=true&"
import script from "./RecoveryStart.vue?vue&type=script&lang=js&"
export * from "./RecoveryStart.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryStart.vue?vue&type=style&index=0&id=46e26b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e26b5c",
  null
  
)

export default component.exports